function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "background-mask",
  clipPathUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0.008 C1,0.004,0.998,0,0.994,0 L0.006,0.052 C0.003,0.052,0,0.055,0,0.059 L0.029,0.864 C0.029,0.867,0.031,0.87,0.034,0.87 L0.921,1 C0.925,1,0.928,0.998,0.928,0.994 L1,0.008"
}));

var SvgBackgroundMask = function SvgBackgroundMask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackgroundMask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background-mask.52bcf56f.svg";
export { ForwardRef as ReactComponent };